import React, { useEffect, useState } from 'react'
import { Modal, ProgressBar, Row, Col } from 'react-bootstrap'
import styled from 'styled-components'
import { SIZES } from '../../styles/theme'
import { toast } from 'react-toastify';
import next from '../../images/booth/next_arrow.png'
import prev from '../../images/booth/prev_arrow.png'
import FinishScreen from './FinishScreen';
import { useDispatch, useSelector } from 'react-redux';
import { submitAnswer, appendAnswers, resetAnswers } from 'src/ducks/booth';
import Amplitude from 'src/utils/amplitudeHelper';

const StyledKiosk = styled(Modal)`
  .modal-content {
    border: 2px solid #5A66A7;
    border-radius: 24px;
    margin-top: 10%;
  }
  .modal-content:before {
    content: "";
    width: 0px;
    height: 0px;
    position: absolute;
    border-left: 36px solid #5A66A7;
    border-right: 12px solid transparent;
    border-top: 16px solid #5A66A7;
    border-bottom: 28px solid transparent;
    left: 2px;
    bottom: -32px;
  }
  .modal-content:after {
    content: "";
    width: 0px;
    height: 0px;
    position: absolute;
    border-left: 36px solid #fff;
    border-right: 12px solid transparent;
    border-top: 12px solid #fff;
    border-bottom: 28px solid transparent;
    left: 4px;
    bottom: -28px;
  }
  .modal-header {
    align-items: center;
    margin: 0 32px;
    padding: 16px 0;
    border-bottom: 2px solid #5A66A7;
    .quiz-title {
      display: flex;
      align-items: flex-end;
      width: 40%;
      font-weight: 600;
      font-size: 18px;
      color: #3A2D86;
      margin: 0;
    }
    .status {
      text-align: right;
      small {
        color: #305F72;
        font-weight: bold;
      }
    }
    .progress {
      background-color: #B6F7F2;
      border-radius: 10px;
      height: 8px;
    }
    .progress-bar {
      background-color: #26B4A9;
    }
    .stats {
      text-decoration: underline;
      color: #26B4A9;
      font-size: 14px;
      margin-left: 12px;
      cursor: pointer;
      font-weight: 400;
    }
  }
  .modal-body {
    padding: 16px 32px;
    .question-text {
      font-weight: 600;
      color: #3C3C3C;
      margin: 0;
    }
    .navigate {
      display: flex;
      justify-content: flex-end;
      position: absolute;
      bottom: 10%;
      left: 85%;
      right: 4%;
      img {
        width: 47%;
        cursor: pointer;
      }
    }
  }
`
const ChoiceItem = styled.div`
  display: flex;
  align-items: center;
  cursor: pointer;
  .check-bullet {
    margin-right: 8px;
    border-radius: 50%;
    background-color: white;
    border: 2px solid #3A2D86;
    .bullet {
      height: 10px;
      border-radius: 50%;
      padding: 6px;
      background-color: ${(props) => props.selected ? '#26B4A9' :'white'};
    }
    .show-correct {
      background-color: red;
    }
  }
  .choice-text {
    color: #3C3C3C;
    font-size: 14px;
    margin: 4px 0;
  }
  ${SIZES.mobile} {
    align-items: flex-start;
    .check-bullet {
      margin-right: 12px;
      margin-top: 2px;
    }
    .choice-text {
      margin: 0;
      margin-bottom: 8px;
    }
  }
`

export default function KioskModal({ quiz, kioskOpen, setKioskOpen }) {
  const dispatch = useDispatch()
  const { viewBooth, boothQuizAnswers, userScore } = useSelector((state) => state.booth)
  const [currentLesson, setCurrentLesson] = useState(0)
  const [isFinishScreen, setIsFinishScreen] = useState(userScore === quiz.questionCount)
  const [answerList, setAnswerList] = useState([]) 
  const [answer, setAnswer] = useState('')
  const [numberOfCorrect, setNumberOfCorrect] = useState(0)
  const lesson = quiz[currentLesson] || {question:"",choices:[]}
  const tips = [
    'His name has the most alphabet "A"',
    "Above 4 million.",
    "You should know this.",
    "The more the merrier.",
    "What do you think?",
  ]
  useEffect(() => {
    if (kioskOpen) {
      if (boothQuizAnswers[viewBooth.id] && boothQuizAnswers[viewBooth.id]?.length > 0) {
        setAnswerList(boothQuizAnswers[viewBooth.id])
        dispatch(resetAnswers(viewBooth.id))
      }
      setCurrentLesson(0)
      setIsFinishScreen(userScore === quiz.questionCount)
    }
  }, [kioskOpen])

  useEffect(() => {
    if (currentLesson === quiz.questionCount && quiz.questionCount !== 0) {
      const numberCorrect = boothQuizAnswers[viewBooth.id].filter(item=>item.isCorrect === true).length
      setNumberOfCorrect(numberCorrect)
      if (numberCorrect === quiz.questionCount) {
        const payload = {
          question_ids : boothQuizAnswers[viewBooth.id].map(item=>item.id),
          answer_indexes : boothQuizAnswers[viewBooth.id].map(item=>item.answer)
        }
        Amplitude.submitQuiz()
        dispatch(submitAnswer(viewBooth.id, payload))
      } 
      setIsFinishScreen(true)
      setAnswerList([])
      dispatch(resetAnswers(viewBooth.id))
    } else {
      const foundAnswer = answerList.filter(item=>item.id===quiz[currentLesson].id)
      setAnswer(foundAnswer.length > 0 ? foundAnswer[0].answer : '')
    }
  }, [currentLesson])

  const answerQuestion = (index) => {
    setAnswer(index)
  }

  const onClickBtn = (btn) => {
    if (btn === "next"){ 
      if(answer === ''){
        toast("Please select an answer.")
      } else{
        let newList;
        if (answerList.filter(item=>item.id===quiz[currentLesson].id).length > 0){
          newList = answerList.map(item=>{
            if (item.id===quiz[currentLesson].id){
              return { id: item.id, answer: answer, isCorrect: quiz[currentLesson].answer_index === answer }
            } else {
              return item
            }
          })
        } else {
          newList = [
            ...answerList,
            { id: quiz[currentLesson].id, answer: answer, isCorrect: quiz[currentLesson].answer_index === answer}
          ]
        }
        setAnswerList(newList)
        dispatch(appendAnswers(viewBooth.id, newList))
        setCurrentLesson(currentLesson + 1)
      }
    }
    if (btn === "prev") setCurrentLesson(currentLesson - 1)
  }

  return (
    <StyledKiosk show={kioskOpen} onHide={() => setKioskOpen(false)} size="lg" aria-labelledby="kiosk-modal" >
      {isFinishScreen ? <FinishScreen numberOfCorrect={numberOfCorrect} /> :
        (<>
          <Modal.Header>
            <p className="quiz-title">
              Hyruan ONE Quiz
            </p>
            <div className="status" style={{width: '38%'}}>
              <ProgressBar variant="default" now={(currentLesson+1)/quiz.questionCount * 100} />
            </div>
            <div className="status">
              <small>Question {currentLesson+1 > quiz.questionCount ? quiz.questionCount : currentLesson+1} out of {quiz.questionCount}</small>
            </div>
          </Modal.Header>
          <Modal.Body>
            <p className="question-text">{lesson.title}</p>
            <small className="font-italic text-muted">Tips: {tips[currentLesson]}</small>
            <Row noGutters className="mt-3 mb-5">
              {lesson.choices.map((option, index)=>(
                <Col md={6} key={option}>
                  <ChoiceItem
                    onClick={()=>answerQuestion(index)} 
                    selected={index === answer}
                  >
                    <div className="check-bullet">
                      <div className="bullet"></div>
                    </div>
                    <p className="choice-text">{option}</p>
                  </ChoiceItem>
                </Col>
              ))}
            </Row>
            <div className="navigate">
              { currentLesson > 0 && <img id="prev-button" src={prev} alt="prev icon" onClick={()=>onClickBtn('prev')} />}
              { currentLesson !== quiz.questionCount && <img id="next-button" src={next} alt="next icon" onClick={()=>onClickBtn('next')} />}
            </div>
          </Modal.Body>
        </>) 
      }
    </StyledKiosk>
  )

}
